import { debounce } from 'throttle-debounce'

const stringStoredParcellesVues = sessionStorage.getItem('parcellesVues')
let arrayStoredParcellesVues: string[] = []
if (stringStoredParcellesVues !== null) {
  arrayStoredParcellesVues = JSON.parse(stringStoredParcellesVues)
}

const debouncedPersist = debounce(500, () => {
  sessionStorage.setItem(
    'parcellesVues',
    JSON.stringify(arrayStoredParcellesVues)
  )
})

export const setParcelleVue = (parcelleId: string) => {
  if (arrayStoredParcellesVues.indexOf(parcelleId) === -1) {
    arrayStoredParcellesVues = [...arrayStoredParcellesVues, parcelleId]
    debouncedPersist()
  }
}
export const checkParcelleVue = (parcelleId: string) =>
  arrayStoredParcellesVues.indexOf(parcelleId) !== -1
